import Analytics from './analyticsInterface';

interface DynamicEvent {
    eventName: string;
    analyticItems: AnalyticsItem[];
}

interface AnalyticsItem {
    name: string;
    value: string | NestedValue;
}

interface NestedValue {
    [key: string]: string | NestedValue;
}

// Declare gtag function from the global scope
declare global {
    interface Window {
        gtag: Function;
    }
}

export class GoogleAnalyticsTracker implements Analytics {
    track(trackingData?: { dynamicEvents?: DynamicEvent[] }): void {
        // Implement logic to send events to Google Analytics
        if (trackingData && trackingData.dynamicEvents) {
            trackingData.dynamicEvents.forEach((dynamicEvent: DynamicEvent) => {
                const { eventName, analyticItems } = dynamicEvent;

                if (window.gtag) {
                    const eventTrackingData: Record<string, any> = {};

                    analyticItems?.forEach((item) => {
                        eventTrackingData[item.name] = item.value;
                    });

                    const eventParams = { ...eventTrackingData };

                    window.gtag('event', eventName, eventParams);
                }
            });
        }
    }
}
